export default {
  getPaises: state => state.paises,
};
